import {Card, DataStatus} from 'platform/components';
import {Grid, Show, VStack} from 'platform/foundation';

import {
  useGetCebiaAutotracerAndReportConfigQuery,
  useGetCebiaRokvyConfigQuery,
} from '@dms/api/core';
import {FullVehicleResponseBody} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {CebiaAutotracerWidget, CebiaProductionYearWidget} from '@dms/teas';

import {useNavigate} from 'shared/web';

type ComponentProps = {
  vehicle?: FullVehicleResponseBody;
};

export function BusinessCasePurchaseVehicleCheck({vehicle}: ComponentProps) {
  const navigate = useNavigate();

  const {data: cebiaAutotracerAndReportConfig, isLoading: isCebiaAutotracerAndReportConfigLoading} =
    useGetCebiaAutotracerAndReportConfigQuery();
  const {data: cebiaRokvyConfig, isLoading: isCebiaRokvyConfigLoading} =
    useGetCebiaRokvyConfigQuery();

  const isEmpty = !cebiaAutotracerAndReportConfig?.enabled && !cebiaRokvyConfig?.enabled;
  const isLoading = isCebiaAutotracerAndReportConfigLoading || isCebiaRokvyConfigLoading;

  return (
    <Grid columns={[1, 2, 2]}>
      <Card
        title={i18n.t('entity.vehicle.labels.integrations')}
        actions={[
          {
            type: 'button',
            variant: 'link',
            leftIcon: 'action/settings',
            onClick: () => navigate(settingsRoutes.vehicleServices),
            title: i18n.t('general.labels.settings'),
            'data-testid': testIds.businessCase.buying('integrationSettingsButton'),
          },
        ]}
      >
        <VStack spacing={3}>
          <DataStatus
            isEmpty={isEmpty}
            isLoading={isLoading}
            emptyMessage={i18n.t('entity.vehicle.emptyIntegration.noServicesAvailable')}
            emptySubheadline={i18n.t('entity.vehicle.emptyIntegration.enableInSettings')}
          >
            <Show when={vehicle}>
              {(vehicle) => (
                <>
                  <Show when={cebiaAutotracerAndReportConfig?.enabled}>
                    <CebiaAutotracerWidget
                      vehicle={vehicle}
                      data-testid={testIds.businessCase.buying('cebiaAutotracerWidget')}
                    />
                  </Show>
                  <Show when={cebiaRokvyConfig?.enabled}>
                    <CebiaProductionYearWidget
                      vehicle={vehicle}
                      data-testid={testIds.businessCase.buying('cebiaProductionYearWidget')}
                    />
                  </Show>
                </>
              )}
            </Show>
          </DataStatus>
        </VStack>
      </Card>
    </Grid>
  );
}
